import React from 'react'
import { createPortal } from 'react-dom'
import { Modal, Button } from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'
import useUser from '../../../hooks/use-user'
import UserImage from '../image'
import BusyModal from '../../modals/busy'
import UserGrade from '../grade'
import { X } from 'react-bootstrap-icons'
import UserProfile from '../profile'
import useClientLocation from '../../../hooks/use-client-location'

const UserProfileModal = ({
    userId,
    onHide = () => {}
}) => {
    return createPortal(
        <Modal
            show
            dialogClassName="modal-90w"
            onHide={() => onHide()}
        >
            <Modal.Body style={{ padding: '0px' }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        zIndex: '100'
                    }}
                >
                    <Button variant='link' onClick={() => onHide()}>
                        <X size={30} />
                    </Button>
                </div>
                <div style={{ maxHeight: '600px', height: '600px' }}>
                    <UserProfile
                        userId={userId}
                    />
                </div>
            </Modal.Body>
        </Modal>
        , document.body)
}

export default UserProfileModal